/**
 * CT BUREAU — LIVE INTELLIGENCE FEED
 * Sample intelligence items — global operations, multi-region
 * Each item mirrors the Claude extraction JSON schema
 */

export const SAMPLE_INTEL_ITEMS = [
  // ── FLASH ── (Extracted from KDF Weekly Threat Posture Analysis) ────────────

  {
    id: "KDF-001",
    feed_id: "feed-kdf-001",
    type: "INCIDENT",
    urgency: "FLASH",
    date_observed: "2026-03-02",
    time_observed: "19:00",
    location: {
      place_name: "Elade",
      county: "Gedo Region",
      country: "Somalia",
      coordinates: "3.1200,41.8500",
      border_proximity: "approx. 60km from Kenya border",
      location_detail: "Gerille–Mandera–Wajir axis, deep ops north",
    },
    description:
      "Forty (40) Al-Shabaab militants arrived at ELADE from BUALE onboard three (3) technicals armed with AK-47 rifles, RPGs and PKM machine guns. Large armed convoy represents significant force concentration — consistent with pre-offensive staging posture.",
    threat_actor: "Al-Shabaab (HSM)",
    personnel_count: 40,
    weapons_observed: ["AK-47 rifles", "RPG launchers", "PKM machine guns", "3x technicals (armed)"],
    casualties: { killed: 0, wounded: 0, missing: 0, kidnapped: 0 },
    movement_direction: "Arrived from BUALE — staging at ELADE",
    source_type: "HUMINT",
    confidence: "HIGH",
    confidence_rationale: "Multiple local source reports corroborated. Vehicle count and armament detail consistent across sources.",
    actionable: true,
    action_required:
      "Alert KDF FOBs in sub-sector north. Request aerial reconnaissance of ELADE grid. Adjust patrol patterns to account for technical vehicle threat. Heighten IED detection posture on MSRs.",
    anomaly_flags: ["Technical convoy of this size uncommon in this sector", "BUALE origin suggests Jubbaland command involvement"],
    tags: ["technical", "convoy", "elade", "buale", "armed-movement", "as"],
    source_report: "KDF-THREAT-POSTURE-16JUN22",
    extracted_at: "2026-03-02T19:30:00Z",
    read: false,
  },

  {
    id: "KDF-002",
    feed_id: "feed-kdf-002",
    type: "INCIDENT",
    urgency: "FLASH",
    date_observed: "2026-03-04",
    time_observed: "21:30",
    location: {
      place_name: "RIBA Patrol Base / QRU Camp",
      county: "Mandera County",
      country: "Kenya",
      coordinates: "3.9100,41.4800",
      border_proximity: "Kenya-Somalia border zone",
      location_detail: "Sub-sector north, Gerille–Mandera–Wajir axis",
    },
    description:
      "Unknown number of Al-Shabaab attacked RIBA patrol base and QRU camp simultaneously using RPG, AK-47 rifles and PKM machine guns. Officers from both camps repulsed the attackers. No injuries on friendly forces side during the incident. Attack indicates enemy reconnaissance of camp readiness levels prior to main assault.",
    threat_actor: "Al-Shabaab (HSM)",
    personnel_count: null,
    weapons_observed: ["RPG launchers", "AK-47 rifles", "PKM machine guns"],
    casualties: { killed: 0, wounded: 0, missing: 0, kidnapped: 0 },
    movement_direction: "Withdrew after contact",
    source_type: "PATROL",
    confidence: "HIGH",
    confidence_rationale: "KDF post-contact report. Physical evidence of RPG impact recovered. Both camp commanders confirmed attack.",
    actionable: true,
    action_required:
      "Increase standby posture at RIBA and QRU camps. Assume attack was a readiness probe — main assault may follow. Improve perimeter lighting and early warning systems. Request QRF reinforcement.",
    anomaly_flags: ["Simultaneous dual-camp attack — coordinated operation", "Probe attack pattern consistent with pre-main-assault TTPs"],
    tags: ["camp-attack", "riba", "qru", "rpg", "mandera", "as"],
    source_report: "KDF-THREAT-POSTURE-25JUN22",
    extracted_at: "2026-03-04T22:00:00Z",
    read: false,
  },

  {
    id: "KDF-003",
    feed_id: "feed-kdf-003",
    type: "THREAT_INDICATOR",
    urgency: "FLASH",
    date_observed: "2026-03-04",
    time_observed: "00:00",
    location: {
      place_name: "Omar Jillow / Arabia Border Crossing",
      county: "Mandera County",
      country: "Kenya",
      coordinates: "3.8500,41.3000",
      border_proximity: "Kenya-Somalia border",
      location_detail: "Kenya-Somalia border, Mandera sector",
    },
    description:
      "Intelligence reports confirmed approximately seventy (70) Al-Shabaab militants crossed from Somalia into Kenya in two groups between OMAR JILLOW and ARABIA. Militants are assessed to be within the GARI hills area. Sources indicate their primary mission is to disrupt election campaigns in MANDERA County by targeting convoys between ELWAK and RHAMU.",
    threat_actor: "Al-Shabaab (HSM)",
    personnel_count: 70,
    weapons_observed: ["AK-47 rifles (assumed)", "Suspected IED materials"],
    casualties: { killed: 0, wounded: 0, missing: 0, kidnapped: 0 },
    movement_direction: "Infiltrated into GARI hills — election convoy targeting confirmed intent",
    source_type: "HUMINT",
    confidence: "HIGH",
    confidence_rationale: "Multiple intelligence sources confirm infiltration and stated mission. Consistent with assessed election-period threat pattern.",
    actionable: true,
    action_required:
      "Immediate suspension of non-essential convoys between ELWAK and RHAMU. Deploy blocking forces to GARI hills. Alert GSU and police on all Mandera election convoy routes. Aerial reconnaissance of GARI hills area.",
    anomaly_flags: ["Largest confirmed single cross-border infiltration in reporting period", "Election targeting — political objective, not military target"],
    tags: ["mass-infiltration", "border-crossing", "election", "mandera", "convoy-threat", "as"],
    source_report: "KDF-THREAT-POSTURE-25JUN22",
    extracted_at: "2026-03-04T06:00:00Z",
    read: false,
  },

  {
    id: "KDF-004",
    feed_id: "feed-kdf-004",
    type: "INCIDENT",
    urgency: "FLASH",
    date_observed: "2026-03-05",
    time_observed: "15:30",
    location: {
      place_name: "Gadondhoowe",
      county: "Gedo Region",
      country: "Somalia",
      coordinates: "3.4100,41.9200",
      border_proximity: "Near Kenya-Somalia border",
      location_detail: "Gerille–Mandera–Wajir axis",
    },
    description:
      "Five (5) Al-Shabaab militants armed with 2x IEDs, 4x grenades, 4x AK-47 rifles and 1x RPG arrived at GADONDHOOWE from ELADE onboard a red Toyota Hilux. Presence of multiple IEDs and RPG indicates a mission-ready assault or emplacement team, likely targeting MSRs or KDF FOB approaches.",
    threat_actor: "Al-Shabaab (HSM)",
    personnel_count: 5,
    weapons_observed: ["2x IEDs", "4x AK-47 rifles", "1x RPG", "4x grenades", "Red Toyota Hilux"],
    casualties: { killed: 0, wounded: 0, missing: 0, kidnapped: 0 },
    movement_direction: "Arrived from ELADE",
    source_type: "HUMINT",
    confidence: "HIGH",
    confidence_rationale: "Source with direct observation. Weapons detail and vehicle confirmed by second independent report.",
    actionable: true,
    action_required:
      "Alert all MSR patrols — possible IED-laying team active. EOD teams on standby. All vehicle checkpoints to be alert for red Toyota Hilux. Aerial surveillance of GADONDHOOWE area.",
    anomaly_flags: ["IED + RPG combination — dual capability team", "Toyota Hilux pattern consistent with known AS mobile IED teams"],
    tags: ["ied", "rpg", "toyota", "gadondhoowe", "ied-team", "as"],
    source_report: "KDF-THREAT-POSTURE-25JUN22",
    extracted_at: "2026-03-05T16:00:00Z",
    read: false,
  },

  // ── IMMEDIATE ───────────────────────────────────────────────────────────────

  {
    id: "KDF-005",
    feed_id: "feed-kdf-005",
    type: "SIGHTING",
    urgency: "IMMEDIATE",
    date_observed: "2026-03-02",
    time_observed: "17:45",
    location: {
      place_name: "Raraye Manyatta",
      county: "Gedo Region",
      country: "Somalia",
      coordinates: "3.5800,41.7200",
      border_proximity: "8km SW of Elele, near Kenya border",
      location_detail: "General area between Chachabole and Elele settlements",
    },
    description:
      "Local herders reported sighting approximately 25 Al-Shabaab militants armed with AK-47 rifles, PKMs and RPG at a manyatta called RARAYE, located 8km SW of ELELE. Group was well-armed and appeared organised. Presence in this location threatens civilian settlements and KDF patrol routes.",
    threat_actor: "Al-Shabaab (HSM)",
    personnel_count: 25,
    weapons_observed: ["AK-47 rifles", "PKM machine guns", "RPG launchers"],
    casualties: { killed: 0, wounded: 0, missing: 0, kidnapped: 0 },
    movement_direction: "Stationary at RARAYE — direction of travel unknown",
    source_type: "EYEWITNESS",
    confidence: "MEDIUM",
    confidence_rationale: "Herder eyewitness report. Single source but detailed and credible. Consistent with known AS patrol patterns in this area.",
    actionable: true,
    action_required:
      "Alert ELELE settlement. Dispatch patrol to RARAYE area. Warn civilian population to restrict movements. Increase aerial surveillance.",
    anomaly_flags: ["Group size of 25 indicates battalion-level element in theatre"],
    tags: ["sighting", "raraye", "elele", "armed-group", "as", "herder-report"],
    source_report: "KDF-THREAT-POSTURE-16JUN22",
    extracted_at: "2026-03-02T18:30:00Z",
    read: false,
  },

  {
    id: "KDF-006",
    feed_id: "feed-kdf-006",
    type: "INCIDENT",
    urgency: "IMMEDIATE",
    date_observed: "2026-03-04",
    time_observed: "03:00",
    location: {
      place_name: "Rhamu",
      county: "Mandera County",
      country: "Kenya",
      coordinates: "3.9300,41.1300",
      border_proximity: "4km from Rhamu Police Station",
      location_detail: "Rhamu town area, Mandera County",
    },
    description:
      "RHAMU Safaricom telecommunications mast, located approximately 4km from RHAMU Police Station, was destroyed by Al-Shabaab militants. The mast had not been manned by National Police Reservists (NPRs) for the past one month prior to the attack. Attack degrades communications in the sector and is assessed as deliberate infrastructure targeting ahead of planned operations.",
    threat_actor: "Al-Shabaab (HSM)",
    personnel_count: null,
    weapons_observed: ["Explosives (suspected)", "Small arms"],
    casualties: { killed: 0, wounded: 0, missing: 0, kidnapped: 0 },
    movement_direction: null,
    source_type: "PATROL",
    confidence: "HIGH",
    confidence_rationale: "KDF and police confirmed destruction of mast. Telecommunications outage confirmed by Safaricom. Physical evidence of demolition.",
    actionable: true,
    action_required:
      "Restore NPR presence at all critical infrastructure. Alert comms units of degraded coverage in Rhamu sector. Implement alternative communication protocols. Investigate gap in NPR deployment.",
    anomaly_flags: ["Communications infrastructure attack — pre-operational disruption pattern", "One month without NPR protection — exploited vulnerability"],
    tags: ["infrastructure", "telecoms", "mast", "rhamu", "mandera", "as"],
    source_report: "KDF-THREAT-POSTURE-25JUN22",
    extracted_at: "2026-03-04T04:00:00Z",
    read: false,
  },

  {
    id: "KDF-007",
    feed_id: "feed-kdf-007",
    type: "MOVEMENT",
    urgency: "IMMEDIATE",
    date_observed: "2026-03-01",
    time_observed: "18:30",
    location: {
      place_name: "Gherille Town Approaches",
      county: "Gedo Region",
      country: "Somalia",
      coordinates: "3.7800,41.8200",
      border_proximity: "7km from Gerille Somalia FOB",
      location_detail: "Gerille–Mandera axis, approx. 7km east of Gerille Somalia FOB",
    },
    description:
      "Ten (10) Al-Shabaab militants armed with AK-47 rifles and PKMs carrying heavy luggage were sighted approximately 7km east of GERILLE Somalia FOB advancing towards GHERILLE town. Heavy luggage consistent with mortar components, IED materials or logistics resupply. Proximity to FOB and direction of advance raises threat to forward positions.",
    threat_actor: "Al-Shabaab (HSM)",
    personnel_count: 10,
    weapons_observed: ["AK-47 rifles", "PKM machine guns", "Heavy luggage (suspected weapons/IED materials)"],
    casualties: { killed: 0, wounded: 0, missing: 0, kidnapped: 0 },
    movement_direction: "Advancing westward towards GHERILLE town",
    source_type: "HUMINT",
    confidence: "MEDIUM",
    confidence_rationale: "Single intelligence source. Armament details credible. Advance direction consistent with known AS infiltration route.",
    actionable: true,
    action_required:
      "Alert GERILLE Somalia FOB. Heighten perimeter security. Dispatch observation patrol towards GHERILLE. Check for IED laying activity on approaches.",
    anomaly_flags: ["Heavy luggage near FOB — possible mortar resupply or IED emplacement mission"],
    tags: ["movement", "gherille", "gerille", "fob-threat", "armed-advance", "as"],
    source_report: "KDF-THREAT-POSTURE-16JUN22",
    extracted_at: "2026-03-01T19:00:00Z",
    read: false,
  },

  {
    id: "KDF-008",
    feed_id: "feed-kdf-008",
    type: "INCIDENT",
    urgency: "IMMEDIATE",
    date_observed: "2026-03-05",
    time_observed: "09:30",
    location: {
      place_name: "Dimu–Dabacity Road",
      county: "Mandera County",
      country: "Kenya",
      coordinates: "3.7800,41.6500",
      border_proximity: "Mandera County interior",
      location_detail: "General area between Dimu and Dabacity",
    },
    description:
      "Al-Shabaab militants erected roadblocks in the general area between DIMU and DABACITY. The militants stopped and searched a MANDERA-bound bus from Nairobi, screening for non-locals before releasing the vehicle. Roadblock operations indicate AS territorial control ambitions and threat to civilian freedom of movement.",
    threat_actor: "Al-Shabaab (HSM)",
    personnel_count: null,
    weapons_observed: ["AK-47 rifles (assumed)"],
    casualties: { killed: 0, wounded: 0, missing: 0, kidnapped: 0 },
    movement_direction: "Stationary — roadblock at fixed point",
    source_type: "EYEWITNESS",
    confidence: "HIGH",
    confidence_rationale: "Passenger eyewitness accounts from bus. Driver report filed at Mandera police. Consistent with AS checkpoint tactics.",
    actionable: true,
    action_required:
      "Alert all commercial vehicle operators on Nairobi-Mandera route. Deploy police escort for buses. Armed patrol to DIMU-DABACITY road. Issue public advisory.",
    anomaly_flags: ["Roadblock targeting non-locals — selection profiling", "Daylight operation — increased AS territorial confidence"],
    tags: ["roadblock", "civilian", "bus", "dimu", "dabacity", "mandera", "as"],
    source_report: "KDF-THREAT-POSTURE-25JUN22",
    extracted_at: "2026-03-05T10:00:00Z",
    read: false,
  },

  // ── PRIORITY ────────────────────────────────────────────────────────────────

  {
    id: "KDF-009",
    feed_id: "feed-kdf-009",
    type: "SIGHTING",
    urgency: "PRIORITY",
    date_observed: "2026-03-01",
    time_observed: "16:00",
    location: {
      place_name: "Jabibar",
      county: "Gedo Region",
      country: "Somalia",
      coordinates: "3.6500,41.9500",
      border_proximity: "Near Kenya-Somalia border corridor",
      location_detail: "Gerille–Mandera–Wajir axis, deep ops north",
    },
    description:
      "Approximately thirteen (13) Al-Shabaab militants armed with AK-47 rifles and with their faces covered were sighted at JABIBAR. Face coverings indicate operational awareness and counter-identification measures, suggesting the group was conducting a mission rather than routine patrolling.",
    threat_actor: "Al-Shabaab (HSM)",
    personnel_count: 13,
    weapons_observed: ["AK-47 rifles"],
    casualties: { killed: 0, wounded: 0, missing: 0, kidnapped: 0 },
    movement_direction: null,
    source_type: "HUMINT",
    confidence: "MEDIUM",
    confidence_rationale: "Single local intelligence source. Level of detail on face coverings indicates close observation. Unverified by patrol.",
    actionable: true,
    action_required:
      "Flag JABIBAR location to patrol assets. Monitor for further sightings. Cross-reference with other reports for pattern development.",
    anomaly_flags: ["Face coverings — anti-identification measure, mission-oriented posture"],
    tags: ["sighting", "jabibar", "armed-group", "face-covered", "as"],
    source_report: "KDF-THREAT-POSTURE-16JUN22",
    extracted_at: "2026-03-01T17:00:00Z",
    read: false,
  },

  {
    id: "KDF-010",
    feed_id: "feed-kdf-010",
    type: "INCIDENT",
    urgency: "PRIORITY",
    date_observed: "2026-03-04",
    time_observed: "14:00",
    location: {
      place_name: "Qarsa–Konton MSR Junction",
      county: "Mandera County",
      country: "Kenya",
      coordinates: "3.7500,41.5500",
      border_proximity: null,
      location_detail: "Junction connecting QARSA-KONTON MSR, grid 37NGC 07883 32217",
    },
    description:
      "KONTON KDF FOB offensive patrol acting on intelligence discovered an IED emplaced at a junction connecting QARSA-KONTON MSR at grid 37 NGC 07883 32217. Device was neutralised before detonation. IED presence on MSR indicates active interdiction campaign against KDF logistics and patrol routes.",
    threat_actor: "Al-Shabaab (HSM)",
    personnel_count: null,
    weapons_observed: ["IED (command-detonated, suspected)"],
    casualties: { killed: 0, wounded: 0, missing: 0, kidnapped: 0 },
    movement_direction: null,
    source_type: "PATROL",
    confidence: "HIGH",
    confidence_rationale: "KDF patrol physically recovered device. EOD assessment completed. Grid reference confirmed.",
    actionable: true,
    action_required:
      "EOD sweep of full QARSA-KONTON MSR. Review other junction points for emplacement. Update route risk assessment. Patrol IED report for pattern analysis.",
    anomaly_flags: ["MSR junction targeting — convoy choke-point selection"],
    tags: ["ied", "msr", "konton", "qarsa", "route-clearance", "as"],
    source_report: "KDF-THREAT-POSTURE-25JUN22",
    extracted_at: "2026-03-04T15:00:00Z",
    read: false,
  },

  {
    id: "KDF-011",
    feed_id: "feed-kdf-011",
    type: "SIGHTING",
    urgency: "PRIORITY",
    date_observed: "2026-03-03",
    time_observed: "15:00",
    location: {
      place_name: "Xamaroy / Qulquul",
      county: "Gedo Region",
      country: "Somalia",
      coordinates: "3.2000,42.1000",
      border_proximity: "approx. 80km SE of Burhache",
      location_detail: "Deep ops north, Gedo region",
    },
    description:
      "Reports indicated approximately fifty (50) Al-Shabaab militants armed with AK-47 rifles, PKMs, RPGs and one (1) mortar barrel relocated into the general area of XAMAROY and QULQUUL, approximately 80km SE of BURHACHE. The mortar barrel represents a direct and escalated threat to KDF Forward Operating Bases in the sub-sector.",
    threat_actor: "Al-Shabaab (HSM)",
    personnel_count: 50,
    weapons_observed: ["AK-47 rifles", "PKM machine guns", "RPG launchers", "1x mortar barrel"],
    casualties: { killed: 0, wounded: 0, missing: 0, kidnapped: 0 },
    movement_direction: "Relocation to XAMAROY and QULQUUL — assessed as staging",
    source_type: "HUMINT",
    confidence: "MEDIUM",
    confidence_rationale: "Multiple intelligence reports corroborating relocation. Mortar detail from second independent source.",
    actionable: true,
    action_required:
      "Alert all KDF FOBs in sub-sector north. Mortar threat assessment for FOB defences. Increase aerial surveillance of XAMAROY and QULQUUL grids. Pre-position QRF.",
    anomaly_flags: ["Mortar capability — direct FOB threat", "50-man concentration — largest seen this reporting period"],
    tags: ["mortar", "concentration", "xamaroy", "qulquul", "fob-threat", "as"],
    source_report: "KDF-THREAT-POSTURE-16JUN22",
    extracted_at: "2026-03-03T16:00:00Z",
    read: true,
  },

  {
    id: "KDF-012",
    feed_id: "feed-kdf-012",
    type: "THREAT_INDICATOR",
    urgency: "PRIORITY",
    date_observed: "2026-03-04",
    time_observed: "17:00",
    location: {
      place_name: "Hola Wajeer",
      county: "Boni Enclave",
      country: "Kenya",
      coordinates: "-1.5000,40.8000",
      border_proximity: "Kenya-Somalia common border",
      location_detail: "Sub-sector south, Boni Enclave",
    },
    description:
      "Intelligence reports indicate Al-Shabaab militants held a planning meeting at HOLA WAJEER on 18 June 2022, during which they planned to conduct an attack targeting a KDF FOB along the common border between 15th and 19th of July 2022. Attack planning is at advanced stage with target selection completed.",
    threat_actor: "Al-Shabaab (HSM)",
    personnel_count: null,
    weapons_observed: [],
    casualties: { killed: 0, wounded: 0, missing: 0, kidnapped: 0 },
    movement_direction: null,
    source_type: "HUMINT",
    confidence: "MEDIUM",
    confidence_rationale: "Source with access to AS planning meeting. Date specificity indicates high source proximity but requires corroboration.",
    actionable: true,
    action_required:
      "All KDF FOBs on common border to heighten security posture for 15-19 July window. Review FOB vulnerability assessments. Pre-position QRF. Brief all sub-sector commanders.",
    anomaly_flags: ["Specific date window provided — indicates advanced planning stage", "Boni enclave FOB targeting — possible response to increased KDF presence"],
    tags: ["fob-attack", "planning", "boni", "july-threat", "as"],
    source_report: "KDF-THREAT-POSTURE-25JUN22",
    extracted_at: "2026-03-04T18:00:00Z",
    read: false,
  },

  {
    id: "KDF-013",
    feed_id: "feed-kdf-013",
    type: "SIGHTING",
    urgency: "PRIORITY",
    date_observed: "2026-03-04",
    time_observed: "06:00",
    location: {
      place_name: "Alungu",
      county: "Gedo Region",
      country: "Somalia",
      coordinates: "3.8000,41.2000",
      border_proximity: "approx. 45km NE of Elwak",
      location_detail: "Gerille–Mandera–Wajir axis",
    },
    description:
      "Approximately thirty (30) Al-Shabaab militants armed with AK-47 rifles, PKMs and RPGs crossed the border line from Kenya into Somalia and advanced in the general area of ALUNGU, approximately 45km NE of ELWAK. Cross-border movement in this direction suggests repositioning following completed operations on the Kenya side.",
    threat_actor: "Al-Shabaab (HSM)",
    personnel_count: 30,
    weapons_observed: ["AK-47 rifles", "PKM machine guns", "RPG launchers"],
    casualties: { killed: 0, wounded: 0, missing: 0, kidnapped: 0 },
    movement_direction: "Kenya to Somalia — advancing NE towards ALUNGU",
    source_type: "HUMINT",
    confidence: "MEDIUM",
    confidence_rationale: "Local intelligence source report. Border crossing corroborated by patrol observation of tracks.",
    actionable: true,
    action_required:
      "Track group for further movement reporting. Alert ELWAK sector. Assess whether exfiltration indicates completed mission or temporary repositioning.",
    anomaly_flags: ["Kenya to Somalia direction — unusual exfiltration after possible operations"],
    tags: ["cross-border", "exfiltration", "alungu", "elwak", "as"],
    source_report: "KDF-THREAT-POSTURE-25JUN22",
    extracted_at: "2026-03-04T07:00:00Z",
    read: true,
  },

  // ── ROUTINE ─────────────────────────────────────────────────────────────────

  {
    id: "KDF-014",
    feed_id: "feed-kdf-014",
    type: "HUMAN_TERRAIN",
    urgency: "ROUTINE",
    date_observed: "2026-03-04",
    time_observed: "20:00",
    location: {
      place_name: "Chachabole Village",
      county: "Mandera County",
      country: "Kenya",
      coordinates: "3.7000,41.4000",
      border_proximity: "approx. 14km west of Elele",
      location_detail: "Gerille–Mandera–Wajir axis",
    },
    description:
      "Al-Shabaab militants conducted a community lecture (dawa) at CHACHABOLE village, approximately 14km west of ELELE. Militants urged locals to support their struggle against the infidels and warned against cooperation with government forces. Psyops activity confirms ongoing efforts to consolidate civilian support base ahead of anticipated operations.",
    threat_actor: "Al-Shabaab (HSM)",
    personnel_count: null,
    weapons_observed: [],
    casualties: { killed: 0, wounded: 0, missing: 0, kidnapped: 0 },
    movement_direction: null,
    source_type: "COMMUNITY_REPORT",
    confidence: "MEDIUM",
    confidence_rationale: "Multiple community members reported the lecture. Consistent with known AS dawa methodology.",
    actionable: false,
    action_required: null,
    anomaly_flags: ["Psyops lecture ahead of planned operations — population preparation"],
    tags: ["psyops", "dawa", "chachabole", "civilian-influence", "as"],
    source_report: "KDF-THREAT-POSTURE-25JUN22",
    extracted_at: "2026-03-04T21:00:00Z",
    read: true,
  },

  {
    id: "KDF-015",
    feed_id: "feed-kdf-015",
    type: "SIGHTING",
    urgency: "ROUTINE",
    date_observed: "2026-03-02",
    time_observed: "11:00",
    location: {
      place_name: "Daresalam",
      county: "Gedo Region",
      country: "Somalia",
      coordinates: "3.9200,41.7000",
      border_proximity: "approx. 26km north of Gerille Somalia FOB",
      location_detail: "Deep ops north, Gerille–Mandera axis",
    },
    description:
      "Ten (10) Al-Shabaab militants armed with AK-47 rifles, one (1) RPG and one (1) PKM were sighted at DARESALAM, approximately 26km north of GERILLE Somalia FOB, occupying a makeshift camp. Presence at this location consistent with support cell or logistics staging post serving active operations closer to the border.",
    threat_actor: "Al-Shabaab (HSM)",
    personnel_count: 10,
    weapons_observed: ["AK-47 rifles", "1x RPG", "1x PKM"],
    casualties: { killed: 0, wounded: 0, missing: 0, kidnapped: 0 },
    movement_direction: "Stationary — makeshift camp occupation",
    source_type: "HUMINT",
    confidence: "MEDIUM",
    confidence_rationale: "Source with direct observation of camp. Armament detail credible.",
    actionable: false,
    action_required: null,
    anomaly_flags: [],
    tags: ["sighting", "daresalam", "camp", "armed-group", "as"],
    source_report: "KDF-THREAT-POSTURE-16JUN22",
    extracted_at: "2026-03-02T12:00:00Z",
    read: true,
  },

  {
    id: "KDF-016",
    feed_id: "feed-kdf-016",
    type: "SIGHTING",
    urgency: "ROUTINE",
    date_observed: "2026-03-05",
    time_observed: "17:00",
    location: {
      place_name: "Khadija Haji",
      county: "Gedo Region",
      country: "Somalia",
      coordinates: "3.4500,42.0000",
      border_proximity: "approx. 13km NW of Gadondhoowe",
      location_detail: "Gerille–Mandera axis",
    },
    description:
      "Five (5) Al-Shabaab militants armed with AK-47 rifles arrived at KHADIJA HAJI, approximately 13km NW of GADDONDHOOWE, onboard a white Toyota Probox. Use of civilian vehicle (Probox) is consistent with assessed AS shift in tactics from technicals to low-signature civilian vehicles to minimise aerial detection.",
    threat_actor: "Al-Shabaab (HSM)",
    personnel_count: 5,
    weapons_observed: ["AK-47 rifles", "White Toyota Probox (unmarked)"],
    casualties: { killed: 0, wounded: 0, missing: 0, kidnapped: 0 },
    movement_direction: "Arrived at KHADIJA HAJI",
    source_type: "HUMINT",
    confidence: "LOW",
    confidence_rationale: "Single source report. Vehicle and personnel count detail noted. Cannot confirm weapons were visible.",
    actionable: false,
    action_required: null,
    anomaly_flags: ["White Toyota Probox — low-signature civilian vehicle replacing technicals"],
    tags: ["sighting", "probox", "civilian-vehicle", "tactic-change", "khadija-haji", "as"],
    source_report: "KDF-THREAT-POSTURE-25JUN22",
    extracted_at: "2026-03-05T18:00:00Z",
    read: true,
  },
];


// ── SAMPLE SITREP REPORTS (KDF Weekly Threat Posture PDFs) ─────────────────────
export const SAMPLE_SITREP_REPORTS = [
  {
    id: "sitrep-kdf-16jun22",
    filename: "THREAT POSTURE 16 JUNE 22",
    report_type: "SITREP",
    report_reference: "KDF-THREAT-POSTURE-16JUN22",
    uploaded_at: "2026-03-02T19:30:00Z",
    classification: "RESTRICTED",
    executive_summary:
      "Weekly threat posture assessment for the Kenya-Somalia border sector. Al-Shabaab (HSM) activity has intensified along the Gerille-Mandera-Wajir axis. A significant force concentration of 40 militants (3 technicals) was observed at Elade, indicating pre-offensive staging. A coordinated attack was conducted against a RIBA/QRU camp, resulting in personnel casualties. IED threat on Qarsa-Konton MSR remains elevated. KDF FOBs in the sub-sector north should maintain heightened alert status.",
    full_summary:
      "Intelligence gathered for the week ending 16 June 2022 indicates Al-Shabaab (HSM) is conducting deliberate force concentration operations along the Kenya-Somalia border. Key developments include: (1) A convoy of 40 AS fighters aboard 3 armed technicals arrived at Elade from Buale - consistent with pre-offensive staging. (2) A direct attack on a RIBA/QRU camp by an estimated 30 AS fighters resulted in KIA and WIA among security forces. (3) An IED team was observed in a red Toyota Hilux on the Qarsa-Konton MSR, posing an immediate route denial threat. (4) 13 AS fighters were noted conducting surveillance at Jabibar. (5) 5 AS fighters in civilian attire observed operating in a white Probox near Daresalam - possible ISR or infiltration team. Overall threat level: HIGH. Recommend heightened patrol posture and aerial reconnaissance on key MSRs.",
    threat_level: {
      overall_level: "HIGH",
      justification:
        "Multiple corroborated HUMINT reports indicate Al-Shabaab pre-offensive staging, direct FOB attack activity, and active IED emplacement. Force concentration at Elade and attack on RIBA/QRU camp are significant escalatory indicators.",
    },
    pattern_analysis: {
      trend:
        "Escalating Al-Shabaab activity along Kenya-Somalia border. Shift from harassment to direct engagement with KDF and allied security forces.",
      tactical_assessment:
        "AS employing multi-axis approach: technical-vehicle based manoeuvre elements in the north, IED emplacement on MSRs, and infiltration teams in civilian vehicles. Indicates deliberate planning cycle.",
      predicted_next_activity:
        "Follow-on attack against KDF FOBs in sub-sector north within 7-14 days. IED detonation on Qarsa-Konton MSR highly likely in near term.",
      anomalies: [
        "Technical convoy size at Elade (3 vehicles, 40 personnel) is the largest recorded in this sector in 6 months.",
        "Use of red Toyota Hilux as IED platform - colour/model not previously noted for this role in the AO.",
      ],
      areas_of_concern: [
        "Elade staging area", "Qarsa-Konton MSR", "RIBA/QRU Camp vicinity", "Jabibar surveillance activity",
      ],
    },
  },
  {
    id: "sitrep-kdf-25jun22",
    filename: "THREAT POSTURE 25 JUNE 22",
    report_type: "SITREP",
    report_reference: "KDF-THREAT-POSTURE-25JUN22",
    uploaded_at: "2026-03-05T06:00:00Z",
    classification: "RESTRICTED",
    executive_summary:
      "Weekly threat posture assessment for the Kenya-Somalia border sector. Al-Shabaab activity remains at HIGH threat level with multiple significant incidents. A 70-strong AS element conducted a cross-border infiltration into Kenyan territory. Rhamu telecom infrastructure was destroyed. Roadblocks were established between Dimu and Dabacity. An AS mortar-equipped force of 50 is assessed to be preparing for a major FOB attack scheduled 15-19 July.",
    full_summary:
      "Intelligence for the week ending 25 June 2022 reflects continued Al-Shabaab (HSM) escalation. Key developments: (1) 70 AS fighters with an unspecified number of technicals infiltrated from Somalia into Kenyan territory - largest cross-border incursion recorded in the AO. (2) Rhamu telecom mast was destroyed by AS, degrading civilian and potential security communications capability. (3) AS established roadblocks between Dimu and Dabacity, disrupting freedom of movement. (4) 10 AS fighters were observed advancing on Gherille FOB suggesting probing or pre-attack ISR. (5) 25 AS fighters moved through Raraye. (6) A 50-strong AS element observed with mortars at Xamaroy is assessed to be planning a direct FOB attack during 15-19 July. (7) A Dawa lecture was observed at Chachabole - indicates active recruitment and ideological consolidation. (8) 30 AS exfiltrated through Alungu following operations. Threat assessment: CRITICAL in immediate sub-sector; HIGH overall.",
    threat_level: {
      overall_level: "CRITICAL",
      justification:
        "Largest cross-border incursion recorded. Confirmed mortar-equipped force planning a scheduled FOB attack. Telecom infrastructure destruction and route denial indicate deliberate shaping operations preceding a major offensive.",
    },
    pattern_analysis: {
      trend:
        "AS has shifted to a combined-arms offensive posture. Shaping operations (comms destruction, route denial, ISR of FOBs) indicate transition from harassment to deliberate attack phase.",
      tactical_assessment:
        "AS is conducting classic pre-offensive shaping: isolate (comms/route denial), fix (roadblocks), then strike (FOB attack 15-19 Jul). The 70-strong cross-border infiltration provides a reserve and sustainment element inside Kenyan territory.",
      predicted_next_activity:
        "Major direct attack on one or more KDF FOBs between 15-19 July using mortars and possibly technicals. Cross-border element likely serves as exploitation or exfiltration force.",
      anomalies: [
        "70-strong cross-border infiltration is the largest single incursion in this AO on record.",
        "Dawa activity at Chachabole suggests AS is consolidating local support network in preparation for sustained operations.",
      ],
      areas_of_concern: [
        "Gherille FOB", "Xamaroy staging area", "Dimu-Dabacity MSR", "Rhamu comms node", "Alungu exfil route",
      ],
    },
  },
];

// ── STORAGE KEYS (localStorage cache — still used for synchronous reads) ──────
const FEED_KEY     = "ctb_live_intel_feed";
const REPORTS_KEY  = "ctb_live_intel_reports";
const UNREAD_KEY   = "ctb_live_intel_unread_ids";

// ── API BASE ───────────────────────────────────────────────────────────────────
const API_BASE = process.env.REACT_APP_TERRORISM_SERVER || "/api/";
const _authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

// ── LOCAL CACHE HELPERS (synchronous, used as a fast read layer) ───────────────
export const getFeedItems = () => {
  try { return JSON.parse(localStorage.getItem(FEED_KEY) || "[]"); } catch { return []; }
};

const _saveFeedCache = (items) =>
  localStorage.setItem(FEED_KEY, JSON.stringify(items));

// ── DB-BACKED ASYNC FUNCTIONS ──────────────────────────────────────────────────

/**
 * Fetch all feed items from the DB and refresh the local cache.
 * Returns the items array.
 */
export const loadFeedFromDB = async () => {
  try {
    const res = await fetch(`${API_BASE}live-intel/feed`, { headers: _authHeader() });
    const json = await res.json();
    if (!json.success) return getFeedItems();
    // Map DB columns to the shape the frontend expects
    const items = json.items.map((r) => ({
      ...((r.raw_json) || {}),
      feed_id:         r.feed_id,
      id:              r.feed_id,
      type:            r.type,
      urgency:         r.urgency,
      description:     r.description,
      threat_actor:    r.threat_actor,
      confidence:      r.confidence,
      actionable:      r.actionable,
      action_required: r.action_required,
      place_name:      r.place_name,
      country:         r.country,
      coordinates:     r.coordinates,
      is_read:         r.is_read,
      is_archived:     r.is_archived,
      read:            r.is_read,
      source_report:   r.report_reference,
      extracted_at:    r.createdAt,
      location:        { place_name: r.place_name, country: r.country, coordinates: r.coordinates },
    }));
    _saveFeedCache(items);
    return items;
  } catch {
    return getFeedItems();
  }
};

/**
 * Save new items to DB and prepend to the local cache.
 * Fires intel-feed-update event so notification listeners react.
 */
export const prependFeedItems = async (newItems, sourceFilename = null) => {
  // Persist to DB (fire-and-forget on failure — items are still in cache)
  try {
    const itemsWithMeta = newItems.map((i) => ({ ...i, source_filename: sourceFilename }));
    await fetch(`${API_BASE}live-intel/save-items`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ..._authHeader() },
      body: JSON.stringify({ items: itemsWithMeta }),
    });
  } catch { /* silent — cache still updated */ }

  // Update local cache
  _saveFeedCache([...newItems, ...getFeedItems()]);

  // Track unread IDs
  const existing = getUnreadIntelIds();
  newItems.forEach((i) => existing.add(i.feed_id));
  localStorage.setItem(UNREAD_KEY, JSON.stringify([...existing]));

  // Notify listeners
  window.dispatchEvent(new CustomEvent("intel-feed-update", { detail: { items: newItems } }));
};

/**
 * Soft-delete an item in DB and remove from local cache.
 */
export const deleteFeedItem = async (feedId) => {
  try {
    await fetch(`${API_BASE}live-intel/items/${feedId}`, {
      method: 'DELETE',
      headers: _authHeader(),
    });
  } catch { /* silent */ }
  _saveFeedCache(getFeedItems().filter((i) => i.feed_id !== feedId));
};

/**
 * Update an item in DB and in the local cache.
 */
export const updateFeedItem = async (feedId, updates) => {
  try {
    await fetch(`${API_BASE}live-intel/items/${feedId}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ..._authHeader() },
      body: JSON.stringify(updates),
    });
  } catch { /* silent */ }
  _saveFeedCache(getFeedItems().map((i) => i.feed_id === feedId ? { ...i, ...updates } : i));
};

// ── Unread tracking (local only — DB is_read is separate) ─────────────────────
export const getUnreadIntelIds = () => {
  try { return new Set(JSON.parse(localStorage.getItem(UNREAD_KEY) || "[]")); } catch { return new Set(); }
};

export const getUnreadIntelCount = () => getUnreadIntelIds().size;

export const markAllIntelRead = async () => {
  localStorage.removeItem(UNREAD_KEY);
  try {
    await fetch(`${API_BASE}live-intel/mark-all-read`, { method: 'POST', headers: _authHeader() });
  } catch { /* silent */ }
};

// ── Reports (localStorage only — these are generated PDF blobs, not persisted to DB) ──
export const getSavedReports = () => {
  try { return JSON.parse(localStorage.getItem(REPORTS_KEY) || "[]"); } catch { return []; }
};

export const saveReport = (report) =>
  localStorage.setItem(REPORTS_KEY, JSON.stringify([report, ...getSavedReports()]));

// ── ADMIRALTY CODE (NATO STANAG 2511) ──────────────────────────────────────────
// Source reliability: how trustworthy is the source in general?
export const ADMIRALTY_SOURCE = {
  A: { label: "A", desc: "Completely reliable",        color: "#16A34A" },
  B: { label: "B", desc: "Usually reliable",           color: "#65A30D" },
  C: { label: "C", desc: "Fairly reliable",            color: "#D97706" },
  D: { label: "D", desc: "Not usually reliable",       color: "#EA580C" },
  E: { label: "E", desc: "Unreliable",                 color: "#DC2626" },
  F: { label: "F", desc: "Reliability cannot be judged", color: "#94A3B8" },
};

// Information credibility: how likely is this specific piece of information to be true?
export const ADMIRALTY_INFO = {
  1: { label: "1", desc: "Confirmed by other sources",  color: "#16A34A" },
  2: { label: "2", desc: "Probably true",               color: "#65A30D" },
  3: { label: "3", desc: "Possibly true",               color: "#D97706" },
  4: { label: "4", desc: "Doubtful",                    color: "#EA580C" },
  5: { label: "5", desc: "Improbable",                  color: "#DC2626" },
  6: { label: "6", desc: "Cannot be judged",            color: "#94A3B8" },
};

// Composite Admiralty Code display helper
export const getAdmiraltyLabel = (source, info) => {
  if (!source || !info) return null;
  return `${source}${info}`;
};

export const getAdmiraltyColor = (source, info) => {
  const sc = ADMIRALTY_SOURCE[source]?.color || "#94A3B8";
  const ic = ADMIRALTY_INFO[info]?.color    || "#94A3B8";
  // Use the worse (more cautionary) of the two colours
  const order = ["#16A34A", "#65A30D", "#D97706", "#EA580C", "#DC2626", "#94A3B8"];
  return order.indexOf(sc) >= order.indexOf(ic) ? sc : ic;
};

// ── URGENCY CONFIG ─────────────────────────────────────────────────────────────
export const URGENCY_CONFIG = {
  FLASH:     { color: "#EF4444", bg: "#FEF2F2", label: "FLASH",     rank: 0 },
  IMMEDIATE: { color: "#F59E0B", bg: "#FFFBEB", label: "IMMEDIATE", rank: 1 },
  PRIORITY:  { color: "#0085E5", bg: "#EFF6FF", label: "PRIORITY",  rank: 2 },
  ROUTINE:   { color: "#94A3B8", bg: "#F8FAFC", label: "ROUTINE",   rank: 3 },
};

// ── TYPE CONFIG ────────────────────────────────────────────────────────────────
export const TYPE_CONFIG = {
  SIGHTING:         { color: "#0369A1", bg: "#E0F2FE", label: "SIGHTING" },
  INCIDENT:         { color: "#9F1239", bg: "#FFE4E6", label: "INCIDENT" },
  MOVEMENT:         { color: "#1D4ED8", bg: "#DBEAFE", label: "MOVEMENT" },
  THREAT_INDICATOR: { color: "#92400E", bg: "#FEF3C7", label: "THREAT IND." },
  HUMAN_TERRAIN:    { color: "#5B21B6", bg: "#EDE9FE", label: "HUMAN TERR." },
  ROUTINE:          { color: "#374151", bg: "#F3F4F6", label: "ROUTINE" },
};

// ── CONFIDENCE CONFIG ──────────────────────────────────────────────────────────
export const CONFIDENCE_CONFIG = {
  HIGH:   { color: "#16A34A", label: "HIGH CONF." },
  MEDIUM: { color: "#D97706", label: "MED CONF." },
  LOW:    { color: "#DC2626", label: "LOW CONF." },
};

// ── SORTING ────────────────────────────────────────────────────────────────────
export const sortByUrgency = (items) =>
  [...items].sort((a, b) => {
    const ra = URGENCY_CONFIG[a.urgency]?.rank ?? 4;
    const rb = URGENCY_CONFIG[b.urgency]?.rank ?? 4;
    if (ra !== rb) return ra - rb;
    return new Date(b.extracted_at) - new Date(a.extracted_at);
  });

// ── UNIQUE REGIONS ─────────────────────────────────────────────────────────────
export const getRegions = (items) => {
  const countries = [...new Set(items.map((i) => i.location?.country).filter(Boolean))].sort();
  return ["All Regions", ...countries];
};

// ── FIELD REPORT ──────────────────────────────────────────────────────────────
export const logFieldReport = async (reportData) => {
  const feedId = crypto.randomUUID();
  const item = { ...reportData, feed_id: feedId };
  try {
    const res = await fetch(`${API_BASE}live-intel/field-report`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ..._authHeader() },
      body: JSON.stringify(item),
    });
    const json = await res.json();
    if (!json.success) throw new Error(json.message);
    // Build the local cache shape to match what loadFeedFromDB returns
    const cached = {
      ...item,
      feed_id: feedId,
      id: feedId,
      source_report: null,
      extracted_at: new Date().toISOString(),
      location: {
        place_name: item.place_name,
        country: item.country,
        coordinates: item.coordinates,
        location_detail: item.location_detail,
        border_proximity: item.border_proximity,
      },
    };
    _saveFeedCache([cached, ...getFeedItems()]);
    const existing = getUnreadIntelIds();
    existing.add(feedId);
    localStorage.setItem(UNREAD_KEY, JSON.stringify([...existing]));
    window.dispatchEvent(new CustomEvent("intel-feed-update", { detail: { items: [cached] } }));
    return cached;
  } catch (err) {
    console.error("[FIELD REPORT] save error:", err.message);
    throw err;
  }
};

// ── INTEL CORRELATION ─────────────────────────────────────────────────────────
export const linkIntelItems = async (fromFeedId, toFeedId) => {
  const res = await fetch(`${API_BASE}live-intel/correlate`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ..._authHeader() },
    body: JSON.stringify({ from_feed_id: fromFeedId, to_feed_id: toFeedId }),
  });
  return res.json();
};

export const unlinkIntelItems = async (fromFeedId, targetId) => {
  const res = await fetch(`${API_BASE}live-intel/correlations/${fromFeedId}/${targetId}`, {
    method: "DELETE",
    headers: _authHeader(),
  });
  return res.json();
};

export const getCorrelations = async (feedId) => {
  try {
    const res = await fetch(`${API_BASE}live-intel/correlations/${feedId}`, {
      headers: _authHeader(),
    });
    const json = await res.json();
    return json.success ? json : { correlations: [], count: 0 };
  } catch {
    return { correlations: [], count: 0 };
  }
};

// ── INTEL ASSESSMENTS ─────────────────────────────────────────────────────────
export const saveAssessment = async (assessmentData) => {
  const res = await fetch(`${API_BASE}live-intel/assessments`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ..._authHeader() },
    body: JSON.stringify(assessmentData),
  });
  return res.json();
};

export const getAssessment = async (feedId) => {
  try {
    const res = await fetch(`${API_BASE}live-intel/assessments/${feedId}`, {
      headers: _authHeader(),
    });
    const json = await res.json();
    return json.success ? json.assessment : null;
  } catch {
    return null;
  }
};

// Fetch corroboration counts + assessment flags for a list of feed IDs in one request.
export const fetchBulkMeta = async (feedIds) => {
  try {
    const res = await fetch(`${API_BASE}live-intel/feed/bulk-meta`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ..._authHeader() },
      body: JSON.stringify({ feed_ids: feedIds }),
    });
    const json = await res.json();
    return json.success ? json.meta : {};
  } catch {
    return {};
  }
};
